import { Button } from "@/components/ui/button";
import { ShoppingBag } from "lucide-react";

interface RegisterButtonProps {
  onClick: () => void;
}

export function RegisterButton({ onClick }: RegisterButtonProps) {
  return (
    <Button
      variant="outline"
      className="w-full max-w-[200px] bg-grace-orange text-white hover:bg-grace-orange/90 border-none h-10 text-sm font-medium rounded-xl shadow-lg transition-all duration-200 hover:shadow-xl"
      onClick={onClick}
    >
      <ShoppingBag className="w-4 h-4 mr-2" />
      Register this device
    </Button>
  );
}